import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { TrendingUp, MapPin, Building2, ShieldCheck } from "lucide-react";
import { MaskedLines, Reveal } from "@/components/site/Reveal";
import { GROWTH_IMG } from "@/lib/site-data";

const PROOF = [
  { icon: TrendingUp, v: "#1", l: "Fastest Growing" },
  { icon: MapPin, v: "4", l: "States Covered" },
  { icon: Building2, v: "20+", l: "Cities & Rising" },
  { icon: ShieldCheck, v: "ISO", l: "Certified Quality" },
];

export const Growth = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [80, -80]);
  const scale = useTransform(scrollYProgress, [0, 0.5, 1], [1.05, 1, 1.05]);

  return (
    <section id="growth" ref={ref} className="relative overflow-hidden py-24 lg:py-32">
      <div className="pointer-events-none absolute inset-0 grain" />
      <div
        className="pointer-events-none absolute left-1/2 top-40 h-[560px] w-[560px] -translate-x-1/2 rounded-full"
        style={{ background: "radial-gradient(circle, rgba(229,57,53,0.10), transparent 62%)" }}
      />

      <div className="relative z-10 mx-auto max-w-[1100px] px-6 text-center lg:px-12">
        <Reveal>
          <p className="mb-5 text-xs font-bold uppercase tracking-[0.3em] text-avatar-red">
            (Momentum)
          </p>
        </Reveal>

        <h2 className="mx-auto max-w-4xl font-heading text-4xl font-bold leading-[0.95] tracking-tighter text-avatar-ink sm:text-6xl lg:text-7xl">
          <MaskedLines lines={["The fastest-growing"]} />
          <span className="block">
            water tank brand in{" "}
            <span className="text-avatar-red">South India.</span>
          </span>
        </h2>

        <Reveal delay={0.15}>
          <p className="mx-auto mt-7 max-w-xl text-base leading-relaxed text-avatar-ink/60 md:text-lg">
            From a single vision to a household name — Avatar is scaling across the
            South, one rooftop at a time. Towering quality. Unmatched trust.
          </p>
        </Reveal>

        {/* cinematic visual */}
        <div className="relative mx-auto mt-16 max-w-2xl">
          <div
            className="pointer-events-none absolute inset-x-0 bottom-0 top-auto h-1/2 rounded-b-[32px]"
            style={{ background: "linear-gradient(to top, #EEF3F9, transparent)" }}
          />
          <motion.div style={{ y }} className="overflow-hidden rounded-[32px] border border-avatar-ink/10">
            <motion.img
              src={GROWTH_IMG}
              alt="Avatar water tank towering above the South India skyline"
              loading="lazy"
              style={{ scale }}
              className="block w-full object-cover"
            />
          </motion.div>
        </div>

        {/* proof row */}
        <div className="mx-auto mt-16 grid max-w-3xl grid-cols-2 gap-8 md:grid-cols-4">
          {PROOF.map((p, i) => (
            <Reveal key={p.l} delay={i * 0.08}>
              <div className="flex flex-col items-center">
                <p.icon size={20} className="mb-3 text-avatar-gold" />
                <div className="font-heading text-4xl font-bold tracking-tighter text-avatar-ink">{p.v}</div>
                <div className="mt-2 text-xs uppercase tracking-wide text-avatar-ink/45">{p.l}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
